import { createUseStyles } from 'react-jss';

export const useActivateYourVaultStyle = createUseStyles({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        width: 460,
    },
    button: {
        fontSize: 14,
        marginTop: 12,
    },
});
